import React from 'react';

import IconBtn from '../../../modules/icon-btn/icon-btn';
import currencyFormat from '../../../utils/currencyFormat';
import { getOrderStatusBadge } from '../../../utils/getStatusBadge';
import { OrdersItemProps } from '../types';

import DotsIcon from './dots-icon.svg';

import './orders-item.scss';

const OrdersItem: React.FC<OrdersItemProps> = ({
  refNumber,
  status,
  title,
  inn,
  count,
  totalCount,
  sum,
  date,
  time,
}) => {
  const getIdNumber = () => {
    if (refNumber.length < 14) {
      const arr = [];
      const splitStr = refNumber.split('').reverse();

      for (let i = 0; i < 14; i += 1) {
        if (splitStr[i]) {
          arr.push(splitStr[i]);
        } else {
          arr.push('0');
        }
      }
      return arr.reverse().join('');
    }
    return refNumber.slice(0, 14);
  };

  return (
    <div className="order-item">
      <div className="order-item__id">{getIdNumber()}</div>
      <div className="order-item__title">{title}</div>
      <div className="order-item__inn">{inn}</div>
      <div className="order-item__count">
        {count} из {totalCount}
      </div>
      <div className="order-item__sum">{currencyFormat(sum)}</div>
      <div className="order-item__date">
        {date} <span>{time}</span>
      </div>
      <div className="order-item__status">{getOrderStatusBadge(status)}</div>
      <div className="order-item__action">
        <IconBtn icon={DotsIcon} />
      </div>
    </div>
  );
};

export default OrdersItem;
